import React from 'react';
import { useTranslation } from 'react-i18next';

import dbdThumbnail from '../../_assets/thumbnail/dbd.webp';
import mymThumbnail from '../../_assets/thumbnail/mym.webp';
import hoyThumbnail from '../../_assets/thumbnail/hoy.webp';
import fmThumbnail from '../../_assets/thumbnail/fm.webp';
import { GameIds } from '../../account/my-games/MyGames.model';
import { useConfig } from '../../ConfigContext';

export function FeaturesCard(): JSX.Element {
  const { t } = useTranslation();
  const config = useConfig();

  return (
    <div className='features-card-container card-bhvra'>
      <div className='feature-container'>
        <img src={dbdThumbnail} alt='feature' className='feature-container-img' />
        <div className='content'>
          <h3>{t('auth.features.dbd-title')}</h3>
          <p>{t('auth.features.dbd-content')}</p>
        </div>
      </div>

      <div className='feature-container'>
        <img
          src={mymThumbnail}
          alt='Registration is now open for Meet Your Maker’s Beta Playtest, coming Winter 2023!'
          className='feature-container-img'
        />
        <div className='content'>
          <h3>{t('auth.features.mym-title')}</h3>
          <p>{t('auth.features.mym-content')}</p>
        </div>
      </div>

      <div className='feature-container'>
        <img src={hoyThumbnail} alt='feature' className='feature-container-img' />
        <div className='content'>
          <h3>{t('auth.features.hoy-title')}</h3>
          <p>{t('auth.features.hoy-content')}</p>
        </div>
      </div>

      {config?.serverConfig.gamesConfig.some((gameConfig) => gameConfig.id === GameIds.FM)
        && (
          <div className='feature-container'>
            <img src={fmThumbnail} alt='feature' className='feature-container-img' />
            <div className='content'>
              <h3>{t('auth.features.fm-title')}</h3>
              <p>{t('auth.features.fm-content')}</p>
            </div>
          </div>
        )}
    </div>
  );
}
